import {
  APP_ID_BUSINESS_BANKING,
  APP_ID_CREDIT_CARD_APP,
  APP_ID_ONE_REDI,
  APP_ID_PCA_APP,
  APP_NAME_CREDIT_CARD,
  APP_NAME_PCA,
  APP_NAME_SMA,
  BOT_NAME_BB_REDI,
  BOT_NAME_CREDIT_CARD,
  BOT_NAME_ONEREDI,
  BOT_NAME_PCA
} from './Constants';

export const getParam = (param) => {
  const params = new URLSearchParams(window.location.hash.substring(1));
  return params.get(param);
};

export const validateParams = () => {
  const validApps = [APP_ID_CREDIT_CARD_APP, APP_ID_ONE_REDI];
  if (
    (window.urlParams.accessTokenFromClient && !window.urlParams.appId) ||
    (validApps.includes(window.urlParams.appId) && window.urlParams.deviceId) ||
    window.urlParams.appId === APP_ID_BUSINESS_BANKING
  ) {
    return null;
  } else throw 'Invalid Params';
};

export const getAppName = (appId) => {
  validateParams();
  const appMap = new Map([
    [APP_ID_PCA_APP, APP_NAME_PCA],
    [APP_ID_BUSINESS_BANKING, APP_NAME_PCA],
    [APP_ID_CREDIT_CARD_APP, APP_NAME_CREDIT_CARD],
    [APP_ID_ONE_REDI, APP_NAME_SMA]
  ]);
  return appMap.get(appId) || APP_NAME_PCA;
};

export const getBotName = (appId) => {
  validateParams();
  const botMap = new Map([
    [APP_ID_PCA_APP, BOT_NAME_PCA],
    [APP_ID_BUSINESS_BANKING, BOT_NAME_BB_REDI],
    [APP_ID_CREDIT_CARD_APP, BOT_NAME_CREDIT_CARD],
    [APP_ID_ONE_REDI, BOT_NAME_ONEREDI]
  ]);
  return botMap.get(appId) || BOT_NAME_PCA;
};
